<template>
  <div class="wrapper">
    <div class="container">
      <div class="image-container">
        <img
          src="../../assets/chameleon-magnifying-glass.png"
          alt="chameleon with magnifying glass"
          class="error-image"
        />
      </div>
      <div class="error-text-container">
        <h2>You already own a Gyre subscription.</h2>
        <h4>
          If you would like to reactivate a cancelled subscription please get in touch with us:
          <a href="mailto:subscriptions@gyreteams.com">subscriptions@gyreteams.com</a>
        </h4>
        <a class="btn btn-default-back" href="/home" data-test="trial-limit-exceeded-button">
          Back to Home
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
.image-container {
  display: flex;
  margin-top: 2rem;
}

.error-image {
  width: clamp(250px, 50%, 800px);
  margin: auto;
}

.error-text-container {
  width: 80%;
  margin: auto;
  text-align: center;

  a {
    margin: 2rem auto;
  }
}
</style>
